import { defineStore } from 'pinia';
import {
  createBaseFilterState,
  createFilterActions,
  createFilterGetters,
} from './filterStoreHelpers';
import sortOptions from '@/constants/sortOptions';

const filterAPI = 'api/transport-requests/available';
const options = { sort: sortOptions.recentlyUpdated };

export const useFilterStore = defineStore('filterStore', {
  state: () => createBaseFilterState(options),
  actions: { ...createFilterActions(filterAPI, options) },
  getters: createFilterGetters(),
});
